export default {
  data () {
    return {
      reportDataType: 'spend',
    }
  },

  computed: {
    metric: function() {
      switch (this.reportDataType) {
        case 'spend':
          return this.returnMetricParams ? { params: { metric: 'spending' } } : 'spending'
        case 'visits':
          return this.returnMetricParams ?  { params: { metric: 'visiting' } } : 'visiting'
      }
    },

    useCurrency: function() {
      return this.reportDataType === 'spend'
    },

    yTickFormat: function () {
      return this.useCurrency ? '$,' : null
    },
  },
}